import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { Breadcrumb, Heading, Spinner } from '../../components/common/atoms'
import { UserAlert } from '../../components/common/atoms/alerts'
import { handleAppError } from '../../components/handlers'
import { Table } from '../../components/common/molecules'
import { invoiceSchema } from '../../schemas/table'
import InvoicesApi from '../../services/invoices.api'
import { commaingNumber } from '../../utils'
import { Tooltip } from 'antd'
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles'

const CompanyInvoices = () => {
  const [localState, setLocalState] = useState({ loading: true }) // change loading to true after api integration
  const [itemsSelected, setItemsSelected] = useState({table1: [], table2: [], table3: []})
  const [viewFulltable, setViewFullTable] = useState({ table2: false, table3: false })
  const [pageloading, setPageLoading] = useState(false)
  const history = useHistory()

  const selectHandler = (event, index, type, data) => {
    const isSelected = event.target.checked
    const to_sub = data && data[data.length - 1].service.trim().toLowerCase().replace(/_/g, ' ') === 'credit note' ? 1:0
    if(isSelected) {
      if(index) setItemsSelected(prevState => { return {...prevState, [type]: [...prevState[type], index]} })
      else setItemsSelected(prevState => { return {...prevState, [type]: data.slice(0, data.length - to_sub).map(item => item.company_invoice_item_id)} })
    } else {
      if(index) setItemsSelected(prevState => { return {...prevState, [type]: prevState[type].filter(item => item !== index)} })
      else setItemsSelected(prevState => { return {...prevState, [type]: []} })
    }
  }

  const downloadInvoices = (type = '') => {
    const index = (parseInt(type.substr(-1), 10) || - 1) - 1
    const { data = [] } = localState
    const company_invoice_id = index > -1 && data.length > index ? data[index].company_invoice_id : ''
    const invoice_items = itemsSelected[type]  

    setPageLoading(true)
    InvoicesApi.download_invoices({ data: { invoice_items, company_invoice_id }, responseType: 'blob'},
      (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/zip'}));
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'invoices.zip')
        link.click()
        link.remove()

        setPageLoading(false)
        setItemsSelected({table1: [], table2: [], table3: []})
      },
      (err) => {
        handleAppError(err)
        setPageLoading(false)
      }
    )
  }

  useEffect(() => {
    InvoicesApi.fetch_invoices({}, 
      (res) => {
        const data = res.data.company_invoices || []

        const data1 = data.length > 0 ? (data[0].credit_note_details ? [...data[0].invoice_items, data[0].credit_note_details] : [...data[0].invoice_items]) : []
        const data1Len = ( data1.length > 0 && data1[data1.length - 1].service.trim().toLowerCase().replace(/_/g, ' ') === 'credit note' ) ? data1.length - 1 : data1.length
        
        const data2 = data.length > 1 ? (data[1].credit_note_details  ? [...data[1].invoice_items, data[1].credit_note_details] :[... data[1].invoice_items]) : []
        const data2Len = ( data2.length > 0 && data2[data2.length - 1].service.trim().toLowerCase().replace(/_/g, ' ') === 'credit note' ) ? data2.length - 1 : data2.length

        const data3 = data.length > 2 ? (data[2].credit_note_details  ? [...data[2].invoice_items, data[2].credit_note_details] : [...data[2].invoice_items]) : []
        const data3Len = ( data3.length > 0 && data3[data3.length - 1].service.trim().toLowerCase().replace(/_/g, ' ') === 'credit note' ) ? data3.length - 1 : data3.length

        setLocalState({ data, data1, data2, data3, data1Len, data2Len, data3Len, isEntityCompany: res.data?.meta?.is_entity_company, loading: false })
      },
      (err) => {
        setLocalState({loading: false})
        handleAppError(err)
       }
    )
  }, [])

  const { data1 = [], data1Len = 0, data2 = [], data2Len = 0, data3 = [], data3Len = 0, data = [], isEntityCompany } = localState
  const {checkboxs, custom_ths} = [[data1, data1Len, 'table1'], [data2, data2Len, 'table2'], [data3, data3Len, 'table3']].reduce((res, item) => {
                  const len = (itemsSelected[item[2]] || []).length  
                  const data = item[0]
                  const dataLen = item[1]
                  const checkbox = <input type='checkbox' onClick={(event) => selectHandler(event, undefined, item[2], data)} checked={len === dataLen} className='h-5 w-5 bg-gray-200 rounded-sm border-gray-300 text-blue-600 focus:ring-0 focus:ring-offset-0 focus:bg-gray-200 cursor-pointer' />
                  const custom_th = len > 0 ? 
                                    (
                                      <div className='px-3 py-2.5 bg-gray-200 flex items-center justify-between'>
                                        <div>
                                          {checkbox}
                                          <span className='ml-20 text-gray-600 font-semibold'>{len} clients selected</span>
                                        </div>
                                        <button className={joinButtonClasses(dsButtonPrimary, 'h-10 px-4')} onClick={() => downloadInvoices(item[2])} >Download Invoices</button>
                                      </div> 
                                    )
                                    : ''
                  return { checkboxs: [...res['checkboxs'], checkbox], custom_ths: [...res['custom_ths'], custom_th]}
                }, {checkboxs: [], custom_ths: []}) 


  const table1MonthYear = (data.length > 0 && data[0].invoice_month) ? data[0].invoice_month : moment().subtract(1, 'months').format('MMMM YYYY')
  const table2MonthYear = (data.length > 1 && data[1].invoice_month) ? data[1].invoice_month : moment(table1MonthYear, 'MMMM YYYY').subtract(1, 'months').format('MMMM YYYY')
  const table3MonthYear = (data.length > 2 && data[2].invoice_month) ? data[2].invoice_month : moment(table2MonthYear, 'MMMM YYYY').subtract(1, 'months').format('MMMM YYYY')
  const tableHeaders = isEntityCompany ? ['SERVICE', 'ENTITY NAME', 'BILL AMOUNT', 'PARTICIPATION LIST', 'INVOICE NO', 'INVOICE STATUS', 'PAYMENT STATUS'] :  ['SERVICE', 'BILL AMOUNT', 'PARTICIPATION LIST', 'INVOICE NO', 'INVOICE STATUS', 'PAYMENT STATUS']
  return (
    <Spinner visible={pageloading}>
      <div className='min-h-screen'>
        <Breadcrumb list={[{text: 'MIS and Invoices', link: '#'}]}/>
        <Heading mainHeading='MIS and Invoices' classes='mt-2' mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl' />
        <UserAlert para='New invoices have been generated. Please accept by 04th of every month or else invoices will be auto confirmed.' icon='blue' classes='p-4 mt-6' paraClasses='leading-5 text-gray-700' />

        {/* table1 */}
        <div className='flex justify-between items-center font-semibold mt-6'>
          <h1 className='text-gray-700 text-base font-semibold mb-0'>{table1MonthYear}</h1>
          <div><Tooltip placement='bottom' title='Total amount = total bill amount - credit note' overlayStyle={{maxWidth : '1000px'}} ><span className='text-gray-500'>TOTAL AMOUNT:</span><span className='text-gray-700 text-base font-semibold ml-2'>₹{commaingNumber(data.length > 0 ? data[0].total_bill : 0)}</span></Tooltip></div>
        </div>
        <Table
          loading={localState.loading}
          headers={data1Len > 0 ? [checkboxs[0], ...tableHeaders] : tableHeaders}
          tableschema={invoiceSchema}
          data={data1}
          classes='rounded-lg mt-3'
          tableClasses='alternate_gray200_color'
          name='table1'
          custom_th={custom_ths.length > 0 ? custom_ths[0] : []}
          itemsSelected={ itemsSelected['table1'] || []}
          selectHandler={selectHandler}
          history={history}
          headerClasses='py-5'
          start_date={moment().subtract(1, 'month').startOf('month').format('DD-MM-YYYY')}
          end_date={moment().subtract(1, 'month').endOf('month').format('DD-MM-YYYY')}
          invoice_id={data.length > 0 ? data[0].company_invoice_id : 0}
          dataLen={data1Len}
          isEntityCompany={isEntityCompany}
        />

        {/* table2 */}
        <div className='flex justify-between items-center font-semibold mt-14'>
          <h1 className='text-gray-700 text-base font-semibold mb-0'>{table2MonthYear}</h1>
          <div><Tooltip placement='bottom' title='Total amount = total bill amount - credit note' overlayStyle={{maxWidth : '1000px'}} ><span className='text-gray-500'>TOTAL AMOUNT:</span><span className='text-gray-700 text-base font-semibold ml-2'>₹{commaingNumber(data.length > 1 ? data[1].total_bill : 0)}</span></Tooltip></div>
        </div>
        <Table
          loading={localState.loading}
          headers={data2Len ? [checkboxs[1], ...tableHeaders] : tableHeaders}
          tableschema={invoiceSchema}
          data={viewFulltable.table2 ? data2 : data2.slice(0, 3)}
          classes='rounded-lg mt-3'
          tableClasses='alternate_gray200_color'
          name='table2'
          headerClasses='py-5'
          custom_th={custom_ths.length > 0 ? custom_ths[1] : []}
          itemsSelected={ itemsSelected['table2'] || []}
          selectHandler={selectHandler}
          history={history}
          start_date={moment().subtract(2, 'month').startOf('month').format('DD-MM-YYYY')}
          end_date={moment().subtract(2, 'month').endOf('month').format('DD-MM-YYYY')}
          invoice_id={data.length > 1 ? data[1].company_invoice_id : 0}
          dataLen={data2Len}
          isEntityCompany={isEntityCompany}
        />
        {data2.length > 3 && 
          <p 
            onClick={() => setViewFullTable(prevState => { return {...prevState, table2: !prevState.table2}})}
            className='text-blue-600 font-semibold text-base mb-0 mt-4 cursor-pointer' 
          >
            {!viewFulltable.table2 ? `${data2.length - 3} more services billed` : 'view less'}
          </p>
        }

        {/* table3 */}
        <div className='flex justify-between items-center font-semibold mt-14'>
          <h1 className='text-gray-700 text-base font-semibold mb-0'>{table3MonthYear}</h1>
          <div><Tooltip placement='bottom' title='Total amount = total bill amount - credit note' overlayStyle={{maxWidth : '1000px'}} ><span className='text-gray-500'>TOTAL AMOUNT:</span><span className='text-gray-700 text-base font-semibold ml-2'>₹{commaingNumber(data.length > 2 ? data[2].total_bill : 0)}</span></Tooltip></div>
        </div>
        <Table
          loading={localState.loading}
          headers={data3Len ? [checkboxs[2], ...tableHeaders] : tableHeaders}
          tableschema={invoiceSchema}
          data={viewFulltable.table3 ? data3 : data3.slice(0, 4)}
          classes='rounded-lg mt-3'
          tableClasses='alternate_gray200_color'
          name='table3'
          headerClasses='py-5'
          custom_th={custom_ths.length > 0 ? custom_ths[2] : []}
          itemsSelected={ itemsSelected['table3'] || []}
          selectHandler={selectHandler}
          history={history}
          start_date={moment().subtract(3, 'month').startOf('month').format('DD-MM-YYYY')}
          end_date={moment().subtract(3, 'month').endOf('month').format('DD-MM-YYYY')}
          invoice_id={data.length > 2 ? data[2].company_invoice_id : 0}
          dataLen={data3Len}
          isEntityCompany={isEntityCompany}
        />
        {data3.length > 3 && 
          <p 
            onClick={() => setViewFullTable(prevState => { return {...prevState, table3: !prevState.table3}})}
            className='text-blue-600 font-semibold text-base mb-0 mt-4 cursor-pointer'
          >
            {!viewFulltable.table3 ? `${data3.length - 3} more services billed` : 'view less'}
          </p>
        }
      </div>
    </Spinner>
  )
}

export default CompanyInvoices
